<template>
  <div>
    <van-nav-bar title="" left-text="back" left-arrow @click-left="onClickLeft" />
    <div id="app">
      <div class="contain">
        <div class="list-box ">
          <div class="title">IDENTITY PROOF</div>
          <div class="flex flex-justify-between flex-align-center relative"
            style="background: #FFF6F1;widows: 100%;padding: 10px;border-radius: 10px;">
            <div class="left flex flex-align-center">
              <img src="https://imgs.hdjfg.com/gift/img/photoproofs_header.png" style="width:42px;height: 42px;"
                class="margin-right-8" />
              <div v-if="form.photoImg">
                <div class="font-13 font-weight-bold" style="color:#999999 ;">
                  Head Image
                </div>
                <div class="font-16 font-weight-bold">
                  {{ getFileName(form.photoImg) }}
                </div>
              </div>
              <div v-else class="font-16 font-weight-bold">
                Head Image
              </div>
            </div>
            <input type="file" accept="image/*" class="van-uploader__input" name="photoImg" id="uploadFile"
              @change="uploadImage">
            <img v-if="form.photoImg" src="https://imgs.hdjfg.com/gift/img/close.png"
              style="width:20px;height: 20px;z-index: 10;" @click.stop="form.photoImg = ''" />
          </div>
          <div class="flex flex-justify-between flex-align-center relative margin-top-10"
            style="background: #FFF6F1;widows: 100%;padding: 10px;border-radius: 10px;">
            <div class="left flex flex-align-center">
              <img src="https://imgs.hdjfg.com/gift/img/photoproofs_header.png" style="width:42px;height: 42px;"
                class="margin-right-8" />
              <div v-if="form.panCardImg">
                <div class="font-13 font-weight-bold" style="color:#999999 ;">
                  PAN Card
                </div>
                <div class="font-16 font-weight-bold">
                  {{ getFileName(form.panCardImg) }}
                </div>
              </div>
              <div v-else class="font-16 font-weight-bold">
                PAN Card
              </div>
            </div>
            <input type="file" accept="image/*" class="van-uploader__input" name="panCardImg" id="uploadFile"
              @change="uploadImage">
            <img v-if="form.panCardImg" src="https://imgs.hdjfg.com/gift/img/close.png"
              style="width:20px;height: 20px;z-index: 10;" @click.stop="form.panCardImg = ''" />
          </div>
          <!-- <div class="flex flex-justify-between flex-align-center relative  margin-top-10"
            style="background: #FFF6F1;widows: 100%;padding: 10px;border-radius: 10px;">
            <div class="left flex flex-align-center">
              <img src="https://imgs.hdjfg.com/gift/img/photoproofs_header.png" style="width:42px;height: 42px;"
                class="margin-right-8" />
              <div v-if="form.badgeImg">
                <div class="font-13 font-weight-bold" style="color:#999999 ;">
                  Employee Badge
                </div>
                <div class="font-16 font-weight-bold">
                  {{ getFileName(form.badgeImg) }}
                </div>
              </div>
              <div v-else class="font-16 font-weight-bold">
                Employee Badge
              </div>
            </div>
            <input type="file" accept="image/*" class="van-uploader__input" name="badgeImg" id="uploadFile"
              @change="uploadImage">
            <img v-if="form.badgeImg" src="https://imgs.hdjfg.com/gift/img/close.png"
              style="width:20px;height: 20px;z-index: 10;" @click.stop="form.badgeImg = ''" />
          </div> -->
          <div class="title  margin-top-14">BANK PROOF</div>
          <div class="flex flex-justify-between flex-align-center relative"
            style="background: #FFF6F1;widows: 100%;padding: 10px;border-radius: 10px;">
            <div class="left flex flex-align-center">
              <img src="https://imgs.hdjfg.com/gift/img/photoproofs_header.png" style="width:42px;height: 42px;"
                class="margin-right-8" />
              <div v-if="form.salaryImg">
                <div class="font-13 font-weight-bold" style="color:#999999 ;">
                  AADHARR
                </div>
                <div class="font-16 font-weight-bold">
                  {{ getFileName(form.salaryImg) }}
                </div>
              </div>
              <div v-else class="font-16 font-weight-bold">
                AADHARR
              </div>
            </div>
            <input type="file" accept="image/*" class="van-uploader__input" name="salaryImg" id="uploadFile"
              @change="uploadImage">
            <img v-if="form.salaryImg" src="https://imgs.hdjfg.com/gift/img/close.png"
              style="width:20px;height: 20px;z-index: 10;" @click.stop="form.salaryImg = ''" />
          </div>
          <!-- <div class="flex flex-justify-between flex-align-center relative margin-top-10"
            style="background: #FFF6F1;widows: 100%;padding: 10px;border-radius: 10px;">
            <div class="left flex flex-align-center">
              <img src="https://imgs.hdjfg.com/gift/img/photoproofs_header.png" style="width:42px;height: 42px;"
                class="margin-right-8" />
              <div v-if="form.bankImg">
                <div class="font-13 font-weight-bold" style="color:#999999 ;">
                  Bank Statements
                </div>
                <div class="font-16 font-weight-bold">
                  {{ getFileName(form.bankImg) }}
                </div>
              </div>
              <div v-else class="font-16 font-weight-bold">
                Bank Statements
              </div>
            </div>
            <input type="file" accept="image/*" class="van-uploader__input" name="bankImg" id="uploadFile"
              @change="uploadImage">
            <img v-if="form.bankImg" src="https://imgs.hdjfg.com/gift/img/close.png"
              style="width:20px;height: 20px;z-index: 10;" @click.stop="form.bankImg = ''" />
          </div> -->
          <!-- <div class="title  margin-top-14">RESIDENTION PROOF</div>
          <div class="flex flex-justify-between flex-align-center relative"
            style="background: #FFF6F1;widows: 100%;padding: 10px;border-radius: 10px;">
            <div class="left flex flex-align-center">
              <img src="https://imgs.hdjfg.com/gift/img/photoproofs_header.png" style="width:42px;height: 42px;"
                class="margin-right-8" />
              <div v-if="form.residentialImg">
                <div class="font-13 font-weight-bold" style="color:#999999 ;">
                  Residention Photo
                </div>
                <div class="font-16 font-weight-bold">
                  {{ getFileName(form.residentialImg) }}
                </div>
              </div>
              <div v-else class="font-16 font-weight-bold">
                Residention Photo
              </div>
            </div>
            <input type="file" accept="image/*" class="van-uploader__input" name="residentialImg" id="uploadFile"
              @change="uploadImage">
            <img v-if="form.residentialImg" src="https://imgs.hdjfg.com/gift/img/close.png"
              style="width:20px;height: 20px;z-index: 10;" @click.stop="form.residentialImg = ''" />
          </div> -->
        </div>
        <div class="fixed repay-box  ">
          <div class="theme-back repay" @click="editImgInfo">
            SAVE
          </div>
        </div>
      </div>



    </div>
  </div>
</template>
<!-- <noscript>
  <img height="1" width="1" style="display:none"
    src="https://www.facebook.com/tr?id=1275319233121938&ev=PageView&noscript=1" />
</noscript> -->
<script>
var OSS = require('ali-oss');
// !function (f, b, e, v, n, t, s) {
//   if (f.fbq) return;
//   n = f.fbq = function () {
//     n.callMethod ?
//       n.callMethod.apply(n, arguments) : n.queue.push(arguments)
//   };
//   if (!f._fbq) f._fbq = n;
//   n.push = n;
//   n.loaded = !0;
//   n.version = '2.0';
//   n.queue = [];
//   t = b.createElement(e);
//   t.async = !0;
//   t.src = v;
//   s = b.getElementsByTagName(e)[0];
//   s.parentNode.insertBefore(t, s)
// }(window, document, 'script',
//   'https://connect.facebook.net/en_US/fbevents.js');
// fbq('init', '1275319233121938');
// fbq('track', 'PageView');
!function (f, b, e, v, n, t, s) {
  if (f.fbq) return; n = f.fbq = function () {
    n.callMethod ?
    n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  };
  if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
  n.queue = []; t = b.createElement(e); t.async = !0;
  t.src = v; s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s)
}(window, document, 'script',
  'https://connect.facebook.net/en_US/fbevents.js');
export default {
  data() {
    return {
      form: {
        photoImg: null,
        panCardImg: null,
        // badgeImg: null,
        salaryImg: null,
        // bankImg: null,
        // residentialImg: null,
      },
      date: "",
      fileList: [],
      ossinfo: null
    }
  },
  created() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear(); // 获取当前年份
    const currentMonth = currentDate.getMonth() + 1; // 获取当前月份（注意：返回值范围为0-11，其中0表示一月，11表示十二月）
    const currentDay = currentDate.getDate(); // 获取当前日期
    this.date = currentYear + "" + currentMonth + "" + currentDay
    this.getToken();
    this.getUserInfo();
  },
  methods: {
    onClickLeft() {
      this.$router.back()
    },
    async getUserInfo() {
      const { data: res } = await this.$http.post('/api/user/info')
      if (res.code === 0) {
        fbq('init',res.data.channel_fbq);
        fbq('track', 'PageView');
      } else {
        this.$toast(res.msg)
      }
    },
    async getToken() {
      const { data: res } = await this.$http.post('/api/oss/getToken')
      if (res.code === 0) {
        console.log(res)
        this.ossinfo = res.data;
      } else {
        this.$toast(res.msg)
      }
    },
    async editImgInfo() {
      const { data: res } = await this.$http.post('/api/user/editImgInfo', this.form)
      if (res.code === 0) {
        fbq('track', 'SubmitApplication');
        this.$dialog.alert({
          title: 'GREAT',
          message: 'we now know all about you.go apply for a loan',
          confirmButtonText: 'GO APPLY',
          theme: 'round-button',
        }).then(() => {
          this.$router.push({
            name: 'details'
          })
        });
      } else {
        this.$toast(res.msg)
      }
    },

    getFileName(url) {
      // 获取URL中的最后一个斜杠后的部分
      const filename = url.substring(url.lastIndexOf('/') + 1);
      return filename;
    },
    getFileExtension(fileName) {
      return fileName.substring(fileName.lastIndexOf(".") + 1);
    },




    async uploadImage(event) {
      console.log(event)
      console.log(event.target.name)
      let name = event.target.name
      const file = event.target.files[0]; // 获取用户选择的图片文件
      console.log(file)
      const fileName = this.getFileExtension(file.name); // 获取文件名
      const client = new OSS({
        // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
        accessKeyId: this.ossinfo.credentials.accessKeyId,
        accessKeySecret: this.ossinfo.credentials.accessKeySecret,
        // 从STS服务获取的安全令牌（SecurityToken）。
        stsToken: this.ossinfo.credentials.securityToken,
        // 填写Bucket名称。
        bucket: this.ossinfo.bucket,
        // 填写Bucket所在地域。以华东1（杭州）为例，yourRegion填写为oss-cn-hangzhou。
        region: this.ossinfo.region,
        // 'oss-ap-south-1',
        secure:true,
        // endpoint:'https'
      });
      let _this = this
      client.put(this.date + "/" + (new Date().getTime()) + "." + fileName, file).then(function (result) {
        switch (name) {
          case 'photoImg':
            _this.form.photoImg = result.url
            break;
          case 'panCardImg':
            _this.form.panCardImg = result.url
            break;
          case 'badgeImg':
            _this.form.badgeImg = result.url
            break;
          case 'salaryImg':
            _this.form.salaryImg = result.url
            break;
          case 'bankImg':
            _this.form.bankImg = result.url
            break;
          case 'residentialImg':
            _this.form.residentialImg = result.url
            break;
          // 可以继续添加更多的case
          default:
          // 如果expression与任何case的值都不匹配时执行的代码
        }


      }).catch(function (err) {
        console.log(err);
      });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.van-cell {
  padding: 14px 0px;
}

.van-uploader {
  display: block !important;
}

.van-uploader__wrapper {
  display: block !important;
}

#app {
  background: #F9F9F9;
  min-height: 100vh;
  padding: 12px 12px 0px 12px;
  box-sizing: border-box;

  .contain {
    background: #FFFFFF;
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.1);
    border-radius: 14px;
    padding: 13px 14px;

    .title {
      font-size: 15px;
      color: #FFA06A;
      font-weight: 500;
      height: 18px;
      line-height: 18px;
      margin-bottom: 20px;
    }

    .left-text {
      color: #999999;
    }

    .repay-box {
      bottom: 10px;
      margin: 0 auto;
      left: 0;
      right: 0;
      width: 299px;

      .repay {
        padding: 12px 128px;
        font-size: 16px;
        color: #FFFFFF;
        font-weight: bold;
        border-radius: 24px;
      }
    }
  }

}</style>
